const formatPrice = (number, locale) => {
  if (number == null || isNaN(number)) return '';

  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
};

export default formatPrice;
